import loadable, { LoadableClassComponent } from '@loadable/component';
import { BENEFIT_TYPE } from 'app/shared/constants/constants';
import { associativeSkelMap } from '../ui/container/mapper-Skeleton';
import { associativeSkelMobileMap } from '../ui/container/mapper-skeleton-mobile';

export const componentLoader = (component: string): LoadableClassComponent<any> => {
  const Component = loadable(() => import('../ui/components/' + component));
  return Component;
};

export const skeletonLoader = (component: string): LoadableClassComponent<any> => {
  const Component = associativeSkelMap.get(component);
  return Component;
};

export const mobileSkeletonLoader = (component: string): LoadableClassComponent<any> => {
  const Component = associativeSkelMobileMap.get(component);
  return Component;
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
};
